// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LayoutRightTop} from 'components/Layout';
import Image from 'components/Image'
import CloseIcon from 'assets/images/driving-zone/btn-popup-close.svg';

type Props = {
  onClose: () => void,
};

export default function ButtonClose(props: Props): React.Element<any> {
  return (
    <LayoutRightTop>
      <CloseButton onClick={props.onClose}>
        <img src={CloseIcon} alt="" />
      </CloseButton>
    </LayoutRightTop>
  );
}

export function ButtonCloseWhite(props: Props): React.Element<any> {
  return (
    <LayoutRightTop>
      <CloseButtonWhite onClick={props.onClose}>
        <Image source="./driving-zone/btn-popup-close-2.png" />
      </CloseButtonWhite>
    </LayoutRightTop>
  );
}

const CloseButton = styled.button`
  width: ${(props) => (props.theme.layout.mobile ? 15 + 46 : 18 + 212)}px;
  height: ${(props) => (props.theme.layout.mobile ? 15 + 46 : 18 + 132)}px;
  padding: ${(props) => (props.theme.layout.mobile ? 23 : 66)}px
    ${(props) => (props.theme.layout.mobile ? 23 : 106)}px;
`;

const CloseButtonWhite = styled.button`
  width: ${(props) => (props.theme.layout.mobile ? 30 : 40)}px;
  height: ${(props) => (props.theme.layout.mobile ? 30 : 40)}px;
  margin: ${(props) => (props.theme.layout.mobile ? 15 : 45)}px
    ${(props) => (props.theme.layout.mobile ? 15 : 95)}px;

  > div {
    width: 100%;
    height: 100%;
  }
`;
